import {useEffect, useState} from 'react';
import {Keyboard, Platform} from 'react-native';

const useKeyboard = () => {
  const [keyBoardHeight, setKeyBoardHeight] = useState(0);

  useEffect(() => {
    const showSubscription = Keyboard.addListener('keyboardDidShow', () => {
      Platform.OS === 'ios' && setKeyBoardHeight(180);
    });

    const hideSubscription = Keyboard.addListener('keyboardDidHide', () => {
      setKeyBoardHeight(0);
    });

    return () => {
      showSubscription.remove();
      hideSubscription.remove();
    };
  }, []);

  return keyBoardHeight;
};

export default useKeyboard;
